export default __webpack_public_path__ + "static/media/Trillium-3840px-1440px.82d12134.jpg";